export default [{
  path: 'vehicleSlefCheckInAdd',
  name: 'vehicleSlefCheckInAdd',
  component: function component() {
    return import('@/views/vehicleCheckInManage/self/add');
  }
}, {
  path: 'vehicleSelfCheckInUpdate',
  name: 'vehicleSelfCheckInUpdate',
  component: function component() {
    return import('@/views/vehicleCheckInManage/self/update');
  }
}, {
  path: 'vehicleSlefCheckInList',
  name: 'vehicleSlefCheckInList',
  component: function component() {
    return import('@/views/vehicleCheckInManage/self/index');
  }
}, {
  path: 'vehicleRentCheckInAdd',
  name: 'vehicleRentCheckInAdd',
  component: function component() {
    return import('@/views/vehicleCheckInManage/rent/add');
  }
}, {
  path: 'vehicleRentCheckInUpdate',
  name: 'vehicleRentCheckInUpdate',
  component: function component() {
    return import('@/views/vehicleCheckInManage/rent/update');
  }
}, {
  path: 'vehicleRentCheckInList',
  name: 'vehicleRentCheckInList',
  component: function component() {
    return import('@/views/vehicleCheckInManage/rent/index');
  }
}, {
  path: 'vehicleSubcontractorCheckInList',
  name: 'vehicleSubcontractorCheckInList',
  component: function component() {
    return import('@/views/vehicleCheckInManage/subcontractorCheck/index');
  }
}, {
  path: 'vehicleSubcontractorCheckInAdd',
  name: 'vehicleSubcontractorCheckInAdd',
  component: function component() {
    return import('@/views/vehicleCheckInManage/subcontractorCheck/add');
  }
}];